module.exports = __webpack_public_path__ + "img/pic_404.609d2f0b.png";